module.exports = __webpack_public_path__ + "img/HTCC-BH1750.1746c50b.jpg";